














































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PaymentHistoryModel } from '@/models/payment-history';

@Component
export default class PaymentHistory extends Vue {
    @Prop({default: []})
    private paymentHistory!: PaymentHistoryModel[];
}
